<label>Category</label>
<ng-select
  [items]="categoryService._productCategories | async"
  bindValue="id"
  bindLabel="product_category"
  [(ngModel)]="value"
  (change)="onChange()"
  multiple="true"
  [loading]="categoryService.gettingRecords"
>
</ng-select>
